import { MouseEvent } from "react";
import SearchHead from "components/searchHead";
import { useTranslation } from "react-i18next";
import SearchForm from "./list/searchForm";
import OptionList from "./list";
import { SEARCH_FORM_ID_ROOM_OPTION } from "components/constent";
import {
  OptionAddInfProvider,
  OptionFilterProvider,
  OptionListProvider,
} from "./context";
import useModalStore from "store/modal";
import OptionCreate from "./create";

export default function OptionPage() {
  const { t } = useTranslation();
  const onSetModal = useModalStore((state) => state.onSetModal);

  // 객실옵션 생성
  const onCreate = (e: MouseEvent<HTMLButtonElement>) => {
    // 생성폼 모달창 오픈
    onSetModal({
      isOpen: true,
      inner: (
        <>
          <OptionAddInfProvider>
            <OptionCreate />
          </OptionAddInfProvider>
        </>
      ),
      styles: "w-full overflow-visible",
      cnclBtn: false,
    });
  };

  return (
    <>
      <SearchHead
        title={t("sub_op_inf")}
        formId={SEARCH_FORM_ID_ROOM_OPTION}
        isCreate
        onClick={onCreate}
      />
      <OptionListProvider>
        <OptionFilterProvider>
          <SearchForm />
        </OptionFilterProvider>
        <OptionList />
      </OptionListProvider>
    </>
  );
}
